import React from 'react';
import {Helmet} from "react-helmet";
import Header from "../../components/Header";
import PartnerSignUps from "../../components/PartnerSignUp";
import Footer from "../../components/Footer";

import './PartnerSignUp.styles.css'; 

const PartnerSignUp = () => {
	
	return (
		<div>
			<Helmet>
				<title>Partner Sign Up</title>
			</Helmet>
			<Header/>
			<PartnerSignUps/>
			<Footer/>
		</div>
	); 
}; 

export default PartnerSignUp;